import React from "react";
import {
  java,
  springboot,
  aws,
  mongodb,
  python,
  azureDevops,
  html,
  css,
  javascript,
  typescript,
  reactLogo,
  tailwindcss,
  github,
  postman,
  jira,
  intellij,
  vscode,
  confluence,
  restAssured,
  postmanTesting,
  junit,
  mockito,
  jmeter,
  jest,
} from "../../assets/index";

const backEnd = [
  { name: "Java", logo: java },
  { name: "Spring Boot", logo: springboot },
  { name: "AWS", logo: aws },
  { name: "Mongo DB", logo: mongodb },
  { name: "Python", logo: python },
  { name: "Azure", logo: azureDevops },
];

const frontEnd = [
  { name: "HTML", logo: html },
  { name: "CSS", logo: css },
  { name: "JavaScript", logo: javascript },
  { name: "TypeScript", logo: typescript },
  { name: "React", logo: reactLogo },
  { name: "Tailwind", logo: tailwindcss },
];

const testing = [
  { name: "RestAssured", logo: restAssured },
  { name: "Postman", logo: postmanTesting },
  { name: "JMeter", logo: jmeter },
  { name: "Mockito", logo: mockito },
  { name: "JUnit", logo: junit },
  { name: "Jest", logo: jest },
];

const tools = [
  { name: "GitHub", logo: github },
  { name: "Postman", logo: postman },
  { name: "Jira", logo: jira },
  { name: "IntelliJ", logo: intellij },
  { name: "VS Code", logo: vscode },
  { name: "Confluence", logo: confluence },
];

const Skills = () => {
  return (
    <section
      id="skills"
      className="w-full h-full py-10 flex border-b-[1px] border-b-black font-titleFont lgl:pb-[100px]"
    >
      <div className="grid grid-cols-2 m-auto items-center gap-8 ">
        <h2 className="row-span-1 col-span-2 text-3xl lg:text-4xl font-normal mx-auto text-black py-4 lgl:py-8">
          Skills
        </h2>
        <div className="skillCard">
          <div className="skillHeading">
            <SkillHeading heading="Backend" />
          </div>
          {backEnd.map((skill) => (
            <SkillCard key={skill.name} skill={skill} />
          ))}
        </div>
        <div className="skillCard">
          <div className="skillHeading">
            <SkillHeading heading="Frontend" />
          </div>
          {frontEnd.map((skill) => (
            <SkillCard key={skill.name} skill={skill} />
          ))}
        </div>
        <div className="skillCard">
          <div className="skillHeading">
            <SkillHeading heading="Testing" />
          </div>
          {testing.map((skill) => (
            <SkillCard key={skill.name} skill={skill} />
          ))}
        </div>
        <div className="skillCard">
          <div className="skillHeading">
            <SkillHeading heading="Tools" />
          </div>
          {tools.map((skill) => (
            <SkillCard key={skill.name} skill={skill} />
          ))}
        </div>
      </div>
    </section>
  );
};

const SkillHeading = ({ heading }) => {
  return (
    <h2 className="text-lg sm:text-xl lgl:text-2xl font-titleFont text-designColor m-auto pb-2">
      {heading}
    </h2>
  );
};

const SkillCard = ({ skill }) => {
  return (
    <div className="col-span-2 lgl:col-span-1 m-auto w-full max-w-20 rounded-lg">
      <div className="m-auto px-5 py-6 rounded-xl mb-2">
        <img src={skill.logo} alt="skillImg" className="w-15 h-15"></img>{" "}
      </div>
      <span className="flex justify-center font-bodyFont text-xs lgl:text-sm w-full h-full truncate text-black">
        {skill.name}
      </span>
    </div>
  );
};

export default Skills;
